import React from "react";
import { PeopleStore } from "./peopleStore";
import { PermissionGroupsStore } from "./permissionGroupsStore";
import { RolesStore } from "./rolesStore";
import { MessageStore } from "./messageStore";
import { ReportingStore } from "./reportingStore";
import { UserStore } from "./userStore";
import { QARStore } from "./qarStore";
import { QARFormStore } from "./qarFormStore";
import { UIStateStore } from "./uiStateStore";
import { AccountStore} from "./accountStore";


export class RootStore {
    constructor() {
        
        this.uiStateStore = new UIStateStore(this);

        this.rolesStore = new RolesStore(this);
        this.peopleStore = new PeopleStore(this);
        this.permissionGroupsStore = new PermissionGroupsStore(this);
        this.messageStore = new MessageStore(this);
        this.reportingStore = new ReportingStore(this);
        this.userStore = new UserStore(this);
        this.qarStore = new QARStore(this);
        this.qarFormStore = new QARFormStore(this);
        this.accountStore = new AccountStore(this);
    }
}

export const RootStoreSingleton = new RootStore();
export const StoresContext = React.createContext(RootStoreSingleton);

// this will be the function available for the app to connect to the stores
export const useStores = () => React.useContext(StoresContext);